<template>
  <div class="personnel-management">
    <!-- Navigation Bar -->
    <div v-if="user.userauthority_govem != 1" class="nav-wrapper">
      <personnel_bar />
    </div>

    <v-container fluid class="main-container">
      <!-- Header Card -->
      <div class="header-card">
        <div class="header-content">
          <div class="header-icon">
            <v-icon size="32" color="primary">mdi-clipboard-text</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">ข้าราชการครูและบุคลากรทางการศึกษา</h2>
            <p class="header-subtitle">จัดการข้อมูลบุคลากรในระบบ</p>
          </div>
        </div>
      </div>

      <!-- Main Content Grid -->
      <v-row class="content-row">
        <!-- Statistics Table -->
        <v-col cols="12" md="8">
          <div class="card stats-card">
            <div class="card-header">
              <h3 class="card-title">สถิติตามประเภท</h3>
              <v-text-field
                v-model="search_postion"
                placeholder="ค้นหา..."
                dense
                outlined
                hide-details
                prepend-inner-icon="mdi-magnify"
                class="search-field-compact"
              ></v-text-field>
            </div>

            <v-data-table
              :items="personnel_sCounts"
              :headers="personnel_sHeaders"
              :search="search_postion"
              class="clean-table"
              hide-default-footer
              :items-per-page="10"
            >
              <template v-slot:item.count_grouptype="{ item }">
                <v-btn
                  :href="
                    '#/admin/print_personnel_type/?type=' + item.position_name
                  "
                  target="_blank"
                  text
                  small
                  color="primary"
                  class="count-btn"
                >
                  {{ item.count_grouptype }}
                  <v-icon small right>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </v-col>

        <!-- Action Panel -->
        <v-col cols="12" md="4">
          <!-- Info Card for Admin -->
          <div v-if="user.userauthority_govem === 1" class="card info-card">
            <div class="info-icon-wrapper">
              <v-icon size="48" color="primary">mdi-chart-bar</v-icon>
            </div>
            <h3 class="info-title">สถิติข้อมูลบุคลากร</h3>
            <p class="info-description">
              แสดงข้อมูลภาพรวมจำนวนข้าราชการครูและบุคลากรทางการศึกษาในระบบ
            </p>
          </div>

          <!-- Action Buttons for Non-Admin -->
          <div v-else class="action-panel">
            <v-btn
              block
              large
              elevation="0"
              color="primary"
              class="action-btn mb-3"
              @click.native="personnel_temporaryAdd()"
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>
              เพิ่มรายการ
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              color="primary"
              class="action-btn mb-3"
              @click.native="personnel_temporaryCSV()"
            >
              <v-icon left>mdi-file-upload</v-icon>
              นำเข้าไฟล์ CSV (เพิ่มและปรับปรุง)
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              color="primary"
              class="action-btn mb-3"
              @click.native="personnel_temporaryAssTeachCSV()"
            >
              <v-icon left>mdi-account-convert</v-icon>
              นำเข้า CSV (ครูผู้ช่วย → ครู)
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              color="primary"
              class="action-btn mb-3"
              @click.native="personnel_temporaryOutofCSV()"
            >
              <v-icon left>mdi-account-remove</v-icon>
              นำเข้าผู้ออกจากระบบ
            </v-btn>

            <v-divider class="my-4"></v-divider>

            <v-btn
              block
              large
              elevation="0"
              outlined
              class="action-btn mb-3"
              @click="UpdateJ18()"
            >
              <v-icon left>mdi-update</v-icon>
              ปรับปรุงข้อมูล จ.18
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              class="action-btn mb-3"
              @click="clearSearch()"
            >
              <v-icon left>mdi-filter-remove</v-icon>
              Clear Search
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              color="error"
              class="action-btn mb-3"
              @click="clearRetireSearch()"
            >
              <v-icon left>mdi-account-clock</v-icon>
              ปรับปรุงข้อมูลผู้เกษียณ
            </v-btn>

            <v-btn
              block
              large
              elevation="0"
              outlined
              class="action-btn"
              @click="repleteSearch()"
            >
              <v-icon left>mdi-content-duplicate</v-icon>
              เลขที่ตำแหน่งซ้ำ
            </v-btn>
          </div>
        </v-col>

        <!-- Search and Filter Section -->
        <v-col cols="12" :md="user.userauthority_govem === 1 ? 12 : 8">
          <div class="card search-card">
            <div class="search-header">
              <h3 class="card-title">ค้นหาและกรองข้อมูล</h3>
            </div>

            <!-- Main Search -->
            <v-text-field
              v-model="search"
              placeholder="ระบุคำค้นหา..."
              outlined
              dense
              hide-details="auto"
              prepend-inner-icon="mdi-magnify"
              v-on:keyup.enter="OnEnter()"
              class="search-field mb-4"
            />

            <!-- Search Type Radio -->
            <v-radio-group row class="search-radio mb-4">
              <v-radio
                label="ชื่อ"
                value="name"
                @click.native="search_name()"
              ></v-radio>
              <v-radio
                label="นามสกุล"
                value="lastname"
                @click.native="search_lastname()"
              ></v-radio>
              <v-radio
                label="รหัสบัตรประชาชน"
                value="idcard"
                @click.native="search_idcard()"
              ></v-radio>
              <v-radio
                label="เลขที่ตำแหน่ง"
                value="idposition"
                @click.native="search_idposition()"
              ></v-radio>
              <v-radio
                label="ปีที่เกษียณ"
                value="yearretire"
                @click.native="search_yearretire()"
              ></v-radio>
              <v-radio
                label="แสดงทั้งหมด"
                value="all"
                @click.native="personnel_temporaryQueryAll()"
              ></v-radio>
            </v-radio-group>

            <!-- Retirement Year Action -->
            <div
              v-if="search >= 2000 && user.userauthority_govem != 1"
              class="mb-4"
            >
              <v-btn
                elevation="0"
                outlined
                :href="
                  '#/admin/print_personnel_retrire_year/?retrire_year=' + search
                "
                target="_blank"
              >
                <v-icon left small>mdi-printer</v-icon>
                พิมพ์ผู้เกษียณปี {{ search }}
              </v-btn>
            </div>

            <!-- Filter Row -->
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="rangname_search"
                  :items="rang_names"
                  item-text="text"
                  item-value="value"
                  label="วิทยฐานะ"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="search_rang()"
                  class="filter-select"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="position_search"
                  :items="position_select"
                  item-text="text"
                  item-value="value"
                  label="ตำแหน่ง"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="search_position()"
                  class="filter-select"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="college_search"
                  :items="users"
                  item-text="agencys"
                  item-value="user_code"
                  label="สถานศึกษา"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="search_college()"
                  class="filter-select"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="user_status_search"
                  :items="userstatus"
                  item-text="user_status_name"
                  item-value="user_status_sub"
                  label="ประเภทบุคคล"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="search_user_status()"
                  class="filter-select"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!-- Duplicate Positions List -->
        <v-col cols="12" md="4" v-if="user.userauthority_govem != 1">
          <div class="card duplicate-card">
            <div class="card-header">
              <h3 class="card-title">ตำแหน่งซ้ำ</h3>
            </div>
            <v-simple-table fixed-header height="250px" class="clean-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">เลขที่ตำแหน่ง</th>
                    <th class="text-center">จำนวน</th>
                    <th class="text-center">ตำแหน่ง</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in personnel_temporary_idpositions"
                    :key="item.id"
                  >
                    <td class="text-center">
                      <v-btn
                        text
                        small
                        color="primary"
                        @click="search_idpositionClick(item.id_position)"
                      >
                        {{ item.id_position }}
                      </v-btn>
                    </td>
                    <td class="text-center">
                      <v-chip small>{{ item.countIDposition }}</v-chip>
                    </td>
                    <td class="text-center text-caption">
                      {{ item.position_name }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>

      <!-- Main Data Table -->
      <div class="card data-table-card">
        <v-data-table
          :headers="filteredHeaders"
          :items="personnel_temporarys"
          :loading="loading"
          :search="search"
          class="clean-table elevation-0"
          loading-text="กำลังโหลดข้อมูล..."
        >
          <!-- Custom slots remain the same, just with updated button styles -->
          <template v-slot:item.viewId="{ item }">
            <v-btn
              :href="'#/user/resume/?id_card=' + item.id_card"
              target="_blank"
              icon
              small
              color="primary"
            >
              <v-icon small>mdi-printer</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.govem_contract="{ item }">
            <v-btn
              v-if="
                String(item.govem_contract).length > 10 &&
                  item.user_status === 'gov_em'
              "
              @click="govem_contract_showDialog(item.govem_contract)"
              icon
              small
              color="primary"
            >
              <v-icon small>mdi-file-document</v-icon>
            </v-btn>
            <v-icon
              v-else-if="item.user_status === 'gov_em'"
              color="error"
              small
            >
              mdi-alert-circle
            </v-icon>
          </template>

          <template v-slot:item.brith_day="{ item }">
            {{ item.brith_day }}/{{ item.brith_month }}/{{ item.brith_year }}
          </template>

          <template v-slot:item.appoin_day="{ item }">
            {{ item.appoin_day }}/{{ item.appoin_month }}/{{ item.appoin_year }}
          </template>

          <template v-slot:item.date_app_now="{ item }">
            {{
              item.date_app_now
                | moment("add", "543 years")
                | moment("D MMMM YYYY")
            }}
          </template>

          <template v-slot:item.date_app_positonnow="{ item }">
            {{
              item.date_app_positonnow
                | moment("add", "543 years")
                | moment("D MMMM YYYY")
            }}
          </template>

          <template v-slot:item.Login="{ item }">
            <v-btn
              icon
              small
              color="primary"
              @click="userLogin(item.id_card, item.p_word)"
            >
              <v-icon small>mdi-login</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.actions="{ item }">           
            <div v-if="user.userauthority_govem === 1">
              <v-btn
                v-if="item.user_status === 'gov_em'"
                icon
                small
                color="warning"
                @click.stop="personnel_temporaryEdit(item.id_card)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-icon v-else small color="grey lighten-1">mdi-minus</v-icon>
            </div>          
            <div v-if="user.userauthorityAdmin === 1">
              <v-btn
                icon
                small
                color="warning"
                @click.stop="personnel_temporaryEdit(item.id_card)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.dels="{ item }">
            <div v-if="user.userauthority_govem === 1">
              <v-btn
                v-if="item.user_status === 'gov_em'"
                icon
                small
                color="error"
                @click.stop="personnel_temporaryDelete(item.id_card)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
              <v-icon v-else small color="grey lighten-1">mdi-minus</v-icon>
            </div>
            <div v-if="user.userauthorityAdmin === 1">
              <v-btn
                icon
                small
                color="error"
                @click.stop="personnel_temporaryDelete(item.id_card)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:no-results>
            <div class="no-results">
              <v-icon large color="grey">mdi-magnify</v-icon>
              <p class="mt-2">ไม่พบผลลัพธ์สำหรับ "{{ search }}"</p>
            </div>
          </template>
        </v-data-table>
      </div>

      <!--addpersonnel_temporarydialog  -->
      <v-layout row justify-center>
        <v-dialog
          v-model="addpersonnel_temporarydialog"
          persistent
          max-width="80%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-account-multiple"
              title="เพิ่มข้อมูลข้าราชการครูและบุคลากรทางการศึกษา"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-form ref="addpersonnel_temporaryform" lazy-validation>
                <v-container grid-list-md>
                  <v-row no-gutters>
                    <v-col cols="12" md="12">
                      <v-radio-group v-model="radiosTpyeOganize" row>
                        <template v-slot:label>
                          <div>
                            สังกัด
                            <strong
                              >วิทยาลัย / สถาบัน / หน่วยศึกษานิเทศก์ /
                              ส่วนกลาง</strong
                            >
                          </div>
                        </template>
                        <v-radio value="college">
                          <template v-slot:label>
                            <div>
                              <strong class="success--text">วิทยาลัย</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="iven">
                          <template v-slot:label>
                            <div>
                              <strong class="primary--text">สถาบัน</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="supervision">
                          <template v-slot:label>
                            <div>
                              <strong class="primary--text"
                                >หน่วยศึกษานิเทศก์</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="ovec">
                          <template v-slot:label>
                            <div>
                              <strong class="primary--text">ส่วนกลาง</strong>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>

                    <v-col cols="12" md="12">
                      <span class="font-weight-bold"
                        >1. ประเภทบุคคล/สังกัด</span
                      >
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        rounded
                        filled
                        v-model="addpersonnel_temporary.user_status"
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_sub"
                        label="Type"
                        required
                        :rules="[v => !!v || '']"
                        prepend-icon="mdi-format-list-bulleted-type"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.college_code"
                        :items="users"
                        item-text="agencys"
                        item-value="user_code"
                        label="วิทยาลัย"
                        @change="man_powerQuery()"
                        required
                        :rules="[v => !!v || '']"
                        prepend-icon="mdi-school"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>
                    <v-col cols="12" md="12"
                      ><span class="font-weight-bold"
                        >2. ข้อมูลพื้นฐาน</span
                      ></v-col
                    >

                    <v-col cols="12" md="3">
                      <v-text-field
                        @input="validateInputAdd()"
                        prepend-icon="mdi-account-key"
                        rounded
                        outlined
                        label="รหัสบัตรประชาชน"
                        v-model="addpersonnel_temporary.id_card"
                        :rules="[
                          v => (!!v && v.length == 13) || '13  ID Card',
                          validateInputcheck === 'true' ||
                            'กำหนดรหัสบัตรประชาชนไม่ถูกต้อง'
                        ]"
                        maxlength="13"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        :items="prefixs"
                        item-text="prefix_name"
                        item-value="prefix_name"
                        prepend-icon="mdi-account-box"
                        rounded
                        outlined
                        label="คำนำหน้าชื่อ"
                        v-model="addpersonnel_temporary.title_s"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        prepend-icon="mdi-account-box"
                        rounded
                        outlined
                        label="ชื่อ"
                        v-model="addpersonnel_temporary.frist_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        prepend-icon="mdi-account-box"
                        rounded
                        outlined
                        label="นามสกุล"
                        v-model="addpersonnel_temporary.last_name"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        :items="days"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.brith_day"
                        label="วันที่เกิด : 8"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        :items="mounts"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.brith_month"
                        label="เดือนเกิด : 8"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        :items="years"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.brith_year"
                        label="ปีเกิด : 2531"
                        type="number"
                        maxlength="4"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        prepend-icon="mdi-cellphone"
                        rounded
                        outlined
                        label="เบอร์โทร"
                        v-model="addpersonnel_temporary.tel_p"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        prepend-icon="mdi-email"
                        rounded
                        outlined
                        label="E-mail"
                        v-model="addpersonnel_temporary.e_mail"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>
                    <v-col cols="12" md="12"
                      ><span class="font-weight-bold">3. ตำแหน่ง</span></v-col
                    >

                    <v-col cols="12" md="4">
                      <v-autocomplete
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.position_name"
                        :items="position_select"
                        item-text="text"
                        item-value="text"
                        label="ตำแหน่ง"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-autocomplete
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.user_status"
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_sub"
                        label="สถานะ"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      v-if="radiosTpyeOganize === 'college'"
                    >
                      <v-autocomplete
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.id_position"
                        :items="man_powers"
                        item-text="id_position"
                        item-value="id_position"
                        label="เลขที่ตำแหน่ง"
                        ><template v-slot:item="{ item }">
                          <div>
                            <div class="font-weight-bold">
                              {{ item.id_position }}
                            </div>
                            <div>{{ item.positions }} : {{ item.id_card }}</div>
                          </div>
                        </template></v-autocomplete
                      >
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      v-if="
                        radiosTpyeOganize === 'iven' ||
                          radiosTpyeOganize === 'supervision' ||
                          radiosTpyeOganize === 'ovec'
                      "
                    >
                      <v-text-field
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.id_position"
                        label="เลขที่ตำแหน่ง"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        prepend-icon="mdi-account-settings"
                        outlined
                        rounded
                        :items="rang_names"
                        item-text="text"
                        item-value="value"
                        label="วิทยฐานะ"
                        v-model="addpersonnel_temporary.rang_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.rang_level"
                        :items="rang_levels"
                        item-text="text"
                        item-value="value"
                        label="ระดับ"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>
                    <v-col cols="12" md="12"
                      ><span class="font-weight-bold"
                        >4. วุฒิการศึกษา</span
                      ></v-col
                    >

                    <v-col cols="12" md="6">
                      <v-text-field
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        label="คุณวิฒิ"
                        v-model="addpersonnel_temporary.ed_abb"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        label="สาขาวิชา"
                        v-model="addpersonnel_temporary.ed_name"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>
                    <v-col cols="12" md="12"
                      ><span class="font-weight-bold">5. การบรรจุ</span></v-col
                    >

                    <v-col cols="12" md="4">
                      <v-autocomplete
                        prepend-icon="mdi-account-settings"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.type_personnel"
                        :items="type_personnelApp"
                        item-text="text"
                        item-value="value"
                        label="ประเภทการบรรจุ"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4" class="pa-5">
                      <v-checkbox
                        v-model="addpersonnel_temporary.rang_condition"
                        value="1"
                        hide-details
                        class="shrink mr-2 mt-0"
                        label="กลุ่ม จชต. ชายแดนภาคใต้"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        prepend-icon="mdi-content-duplicate"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.order_app_now"
                        label="คำสั่งที่บรรจุ"
                      ></v-text-field>
                    </v-col>

                    <!-- บรรจะ -->
                    <v-col cols="12" md="4">
                      <v-select
                        :items="days"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar-clock"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.appoin_day"
                        label="วันที่บรรจุ"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        :items="mounts"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar-clock"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.appoin_month"
                        label="เดือนบรรจุ"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        :items="years"
                        item-text="text"
                        item-value="value"
                        prepend-icon="mdi-calendar-clock"
                        rounded
                        outlined
                        v-model="addpersonnel_temporary.appoin_year"
                        label="ปีบรรจุ"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="12">
                      <hr style="border: 1px solid grey;" />
                    </v-col>
                    <v-col cols="12" md="12"
                      ><span class="font-weight-bold"
                        >6. การปฏิบัติงาน ณ ปัจจุบัน</span
                      ></v-col
                    >

                    <v-col cols="12" md="6">
                      <v-menu
                        ref="menu5"
                        v-model="menu5"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            prepend-icon="mdi-calendar-clock"
                            rounded
                            outlined
                            v-model="addpersonnel_temporary.date_app_now"
                            label="วันเดือนปีที่เริ่มปฏิบัติงาน ณ สถานศึกษาปัจจุบัน"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="addpersonnel_temporary.date_app_now"
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu5 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu5.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-menu
                        ref="menu6"
                        v-model="menu6"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            prepend-icon="mdi-calendar-clock"
                            rounded
                            outlined
                            v-model="addpersonnel_temporary.date_app_positonnow"
                            label="วันเดือนปีที่เริ่มปฏิบัติงาน ใน ตำแหน่งปัจจุบัน"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            locale="th"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="addpersonnel_temporary.date_app_positonnow"
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu6 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu6.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
                <small>* จำเป็น</small>
                <span>ปีเกษียณ :{{ retrire_year }}</span>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="addpersonnel_temporarydialog = false"
                rounded
                ><v-icon dark>mdi-close</v-icon> ยกเลิก</v-btn
              >
              <v-btn
                large
                color="success"
                @click.stop="addpersonnel_temporarySubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model csvpersonnel_temporarydialog -->
      <v-layout>
        <v-dialog
          v-model="csvpersonnel_temporarydialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="green"
              icon="mdi-content-paste"
              title="นำเข้าข้อมูลไฟล์ CSV"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form
                    ref="csvpersonnel_temporarydialogform"
                    lazy-validation
                  >
                    <v-container grid-list-md>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            block
                            large
                            color="info"
                            to="/college/personnel_form_import/"
                            target="_blank"
                          >
                            <v-icon>mdi-exit-to-app</v-icon
                            >ส่งออกไฟล์บันทึกข้อมูล</v-btn
                          >
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-file-input
                            v-model="file2"
                            accept=".csv"
                            name="csvFiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .csv"
                            placeholder="ไฟล์ CSV ข้อมูลบุคคล สอศ"
                            prepend-icon="mdi-paperclip"
                            outlined
                            rounded
                            :show-size="1000"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ files.length - 2 }} File(s)
                              </span>
                            </template>
                          </v-file-input>
                          <v-btn
                            block
                            large
                            color="green"
                            @click.stop="csvpersonnel_temporarySubmit()"
                          >
                            <v-icon>mdi-book-plus</v-icon>
                            นำเข้า</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  large
                  color="grey"
                  @click.stop="csvpersonnel_temporarydialog = false"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model csvpersonnel_temporaryAssTeachdialog -->
      <v-layout>
        <v-dialog
          v-model="csvpersonnel_temporaryAssTeachdialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="green"
              icon="mdi-content-paste"
              title="นำเข้าข้อมูลไฟล์ CSV (ครูผู้ช่วย) เป็น ครู ค.ศ.1"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form
                    ref="csvpersonnel_temporaryAssTeachdialogform"
                    lazy-validation
                  >
                    <v-container grid-list-md>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            block
                            large
                            color="info"
                            to="/admin/personnel_AssTeachform_import/"
                            target="_blank"
                          >
                            <v-icon>mdi-exit-to-app</v-icon
                            >ส่งออกไฟล์บันทึกข้อมูล</v-btn
                          >
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-file-input
                            v-model="file3"
                            accept=".csv"
                            name="csvFiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .csv"
                            placeholder="ไฟล์ CSV ข้อมูลบุคคล สอศ"
                            prepend-icon="mdi-paperclip"
                            outlined
                            rounded
                            :show-size="1000"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ files.length - 2 }} File(s)
                              </span>
                            </template>
                          </v-file-input>
                          <v-btn
                            block
                            large
                            color="green"
                            @click.stop="csvpersonnel_temporaryTeachAssSubmit()"
                          >
                            <v-icon>mdi-book-plus</v-icon>
                            นำเข้า</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  large
                  color="grey"
                  @click.stop="csvpersonnel_temporaryAssTeachdialog = false"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model csvpersonnel_temporaryOutofdialog -->
      <v-layout>
        <v-dialog
          v-model="csvpersonnel_temporaryOutofdialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="green"
              icon="mdi-content-paste"
              title="นำเข้าข้อมูลไฟล์ ผู้ออกจากราชการ ลาออก เกษียณ ถึงแก่กรรม CSV"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form
                    ref="csvpersonnel_temporaryOutofdialogform"
                    lazy-validation
                  >
                    <v-container grid-list-md>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            block
                            large
                            color="info"
                            to="/admin/personneloutof_form_import/"
                            target="_blank"
                          >
                            <v-icon>mdi-exit-to-app</v-icon
                            >ส่งออกไฟล์บันทึกข้อมูล</v-btn
                          >
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-file-input
                            v-model="file2"
                            accept=".csv"
                            name="csvFiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .csv"
                            placeholder="ไฟล์ CSV ข้อมูลบุคคล สอศ"
                            prepend-icon="mdi-paperclip"
                            outlined
                            rounded
                            :show-size="1000"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ files.length - 2 }} File(s)
                              </span>
                            </template>
                          </v-file-input>
                          <v-btn
                            block
                            large
                            color="green"
                            @click.stop="csvpersonnel_temporaryOutofSubmit()"
                          >
                            <v-icon>mdi-book-plus</v-icon>
                            นำเข้า</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  large
                  color="grey"
                  @click.stop="csvpersonnel_temporaryOutofdialog = false"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model deletepersonnel_temporarydialog -->
      <v-layout>
        <v-dialog
          v-model="deletepersonnel_temporarydialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูลผู้ใช้"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text class="text_google">
              <v-card>
                <v-card-text>
                  <v-form ref="deletepersonnel_temporaryform" lazy-validation>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          ยืนยันการลบข้อมูลผู้ใช้
                          {{ editpersonnel_temporary.college_code }}
                          <span v-if="editpersonnel_temporary.college_name">{{
                            editpersonnel_temporary.college_name
                          }}</span>
                          <div>
                            {{ editpersonnel_temporary.title_s
                            }}{{ editpersonnel_temporary.frist_name }}
                            {{ editpersonnel_temporary.last_name }}
                          </div>
                          <div>
                            {{ editpersonnel_temporary.position_name }} :
                            {{ editpersonnel_temporary.id_position }}
                          </div>
                        </v-flex>
                        <v-flex>
                          <v-select
                            v-model="
                              del_personnel_temporary_del.ptdel_status_del
                            "
                            label="ประเภทการลบ"
                            :items="delPersonneltype"
                            item-text="text"
                            item-value="value"
                            outlined
                            rounded
                            :rules="[v => !!v || '']"
                          ></v-select>
                        </v-flex>
                        <v-flex>
                          <v-menu
                            ref="menu8"
                            v-model="menu8"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                prepend-icon="mdi-calendar-clock"
                                rounded
                                outlined
                                v-model="
                                  del_personnel_temporary_del.ptdel_datetime_outof
                                "
                                label="ออกโดยมีผลวันที่"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                locale="th"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                del_personnel_temporary_del.ptdel_datetime_outof
                              "
                              no-title
                              scrollable
                              locale="th"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu8 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu8.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>

                        <v-text-field
                          filled
                          rounded
                          type="password"
                          label="รหัสผ่าน สำหรับลบข้อมูล"
                          :rules="[v => v === '0612698358']"
                        >
                        </v-text-field>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="deletepersonnel_temporarydialog = false"
                ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
              >
              <v-btn
                large
                color="red darken-3"
                @click.stop="deletepersonnel_temporarySubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model editpersonnel_temporarydialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="editpersonnel_temporarydialog"
          persistent
          max-width="80%"
        >
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลผู้ใช้งานระบบ"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editpersonnel_temporaryform" lazy-validation>
                <v-row no-gutters>
                  <v-col cols="12" md="12">
                    <v-radio-group v-model="radiosTpyeOganize" row>
                      <template v-slot:label>
                        <div>
                          สังกัด
                          <strong
                            >วิทยาลัย / สถาบัน / หน่วยศึกษานิเทศก์ /
                            ส่วนกลาง</strong
                          >
                        </div>
                      </template>
                      <v-radio value="college">
                        <template v-slot:label>
                          <div>
                            <strong class="success--text">วิทยาลัย</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="iven">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">สถาบัน</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="supervision">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text"
                              >หน่วยศึกษานิเทศก์</strong
                            >
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="ovec">
                        <template v-slot:label>
                          <div>
                            <strong class="primary--text">ส่วนกลาง</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>

                  <v-col cols="12" md="12">
                    <span class="font-weight-bold">1. ประเภทบุคคล/สังกัด</span>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      rounded
                      filled
                      v-model="editpersonnel_temporary.user_status"
                      :items="userstatus"
                      item-text="user_status_name"
                      item-value="user_status_sub"
                      label="Type"
                      required
                      :rules="[v => !!v || '']"
                      prepend-icon="mdi-format-list-bulleted-type"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-if="editpersonnel_temporary.user_status === 'C'"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.college_code"
                      :items="veivocals"
                      item-text="veiVocalName"
                      item-value="veiVocalID"
                      label="สถาบันการอาชีวศึกษา"
                      @change="man_powerQuery()"
                      required
                      :rules="[v => !!v || '']"
                      prepend-icon="mdi-school"
                    >
                    </v-autocomplete>

                    <v-autocomplete
                      v-else
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.college_code"
                      :items="users"
                      item-text="agencys"
                      item-value="user_code"
                      label="วิทยาลัย"
                      @change="man_powerQuery()"
                      required
                      :rules="[v => !!v || '']"
                      prepend-icon="mdi-school"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>
                  <v-col cols="12" md="12"
                    ><span class="font-weight-bold"
                      >2. ข้อมูลพื้นฐาน</span
                    ></v-col
                  >

                  <v-col cols="12" md="3">
                    <v-text-field
                      readonly
                      @input="validateInput()"
                      prepend-icon="mdi-account-key"
                      rounded
                      outlined
                      label="รหัสบัตรประชาชน"
                      v-model="editpersonnel_temporary.id_card"
                      :rules="[
                        v => (!!v && v.length == 13) || '13  ID Card',
                        validateInputcheck === 'true' ||
                          'กำหนดรหัสบัตรประชาชนไม่ถูกต้อง'
                      ]"
                      maxlength="13"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      :items="prefixs"
                      item-text="prefix_name"
                      item-value="prefix_name"
                      prepend-icon="mdi-account-box"
                      rounded
                      outlined
                      label="คำนำหน้าชื่อ"
                      v-model="editpersonnel_temporary.title_s"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      prepend-icon="mdi-account-box"
                      rounded
                      outlined
                      label="ชื่อ"
                      v-model="editpersonnel_temporary.frist_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      prepend-icon="mdi-account-box"
                      rounded
                      outlined
                      label="นามสกุล"
                      v-model="editpersonnel_temporary.last_name"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      :items="days"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.brith_day"
                      label="วันที่เกิด : 8"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      :items="mounts"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.brith_month"
                      label="เดือนเกิด : 8"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      :items="years"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.brith_year"
                      label="ปีเกิด : 2531"
                      type="number"
                      maxlength="4"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-icon="mdi-cellphone"
                      rounded
                      outlined
                      label="เบอร์โทร"
                      v-model="editpersonnel_temporary.tel_p"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-icon="mdi-email"
                      rounded
                      outlined
                      label="E-mail"
                      v-model="editpersonnel_temporary.e_mail"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>
                  <v-col cols="12" md="12"
                    ><span class="font-weight-bold">3. ตำแหน่ง</span></v-col
                  >

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.position_name"
                      :items="position_select"
                      item-text="text"
                      item-value="text"
                      label="ตำแหน่ง"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.user_status"
                      :items="userstatus"
                      item-text="user_status_name"
                      item-value="user_status_sub"
                      label="สถานะ"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    v-if="radiosTpyeOganize === 'college'"
                  >
                    <v-autocomplete
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.id_position"
                      :items="man_powers"
                      item-text="id_position"
                      item-value="id_position"
                      label="เลขที่ตำแหน่ง"
                      ><template v-slot:item="{ item }">
                        <div>
                          <div class="font-weight-bold">
                            {{ item.id_position }}
                          </div>
                          <div>{{ item.positions }} : {{ item.id_card }}</div>
                        </div>
                      </template></v-autocomplete
                    >
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                    v-if="
                      radiosTpyeOganize === 'iven' ||
                        radiosTpyeOganize === 'supervision' ||
                        radiosTpyeOganize === 'ovec'
                    "
                  >
                    <v-text-field
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.id_position"
                      label="เลขที่ตำแหน่ง"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      prepend-icon="mdi-account-settings"
                      outlined
                      rounded
                      :items="rang_names"
                      item-text="text"
                      item-value="value"
                      label="วิทยฐานะ"
                      v-model="editpersonnel_temporary.rang_name"
                      required
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.rang_level"
                      :items="rang_levels"
                      item-text="text"
                      item-value="value"
                      label="ระดับ"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      type="number"
                      prepend-icon="mdi-currency-btc"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.salary_s"
                      label="เงินเดือน"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>
                  <v-col cols="12" md="12"
                    ><span class="font-weight-bold"
                      >4. วุฒิการศึกษา</span
                    ></v-col
                  >

                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      label="คุณวิฒิ"
                      v-model="editpersonnel_temporary.ed_abb"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      label="สาขาวิชา"
                      v-model="editpersonnel_temporary.ed_name"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>
                  <v-col cols="12" md="12"
                    ><span class="font-weight-bold">5. การบรรจุ</span></v-col
                  >

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      prepend-icon="mdi-account-settings"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.type_personnel"
                      :items="type_personnelApp"
                      item-text="text"
                      item-value="value"
                      label="ประเภทการบรรจุ"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" class="pa-5">
                    <v-checkbox
                      v-model="editpersonnel_temporary.rang_condition"
                      value="1"
                      hide-details
                      class="shrink mr-2 mt-0"
                      label="กลุ่ม จชต. ชายแดนภาคใต้"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      prepend-icon="mdi-content-duplicate"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.order_app_now"
                      label="คำสั่งที่บรรจุ"
                    ></v-text-field>
                  </v-col>

                  <!-- บรรจะ -->
                  <v-col cols="12" md="4">
                    <v-select
                      :items="days"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar-clock"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.appoin_day"
                      label="วันที่บรรจุ"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      :items="mounts"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar-clock"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.appoin_month"
                      label="เดือนบรรจุ"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      :items="years"
                      item-text="text"
                      item-value="value"
                      prepend-icon="mdi-calendar-clock"
                      rounded
                      outlined
                      v-model="editpersonnel_temporary.appoin_year"
                      label="ปีบรรจุ"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="12">
                    <hr style="border: 1px solid grey;" />
                  </v-col>
                  <v-col cols="12" md="12"
                    ><span class="font-weight-bold"
                      >6. การปฏิบัติงาน ณ ปัจจุบัน</span
                    ></v-col
                  >

                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu5"
                      v-model="menu5"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-icon="mdi-calendar-clock"
                          rounded
                          outlined
                          v-model="editpersonnel_temporary.date_app_now"
                          label="วันเดือนปีที่เริ่มปฏิบัติงาน ณ สถานศึกษาปัจจุบัน"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          locale="th"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editpersonnel_temporary.date_app_now"
                        no-title
                        scrollable
                        locale="th"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu5 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu5.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu6"
                      v-model="menu6"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-icon="mdi-calendar-clock"
                          rounded
                          outlined
                          v-model="editpersonnel_temporary.date_app_positonnow"
                          label="วันเดือนปีที่เริ่มปฏิบัติงาน ใน ตำแหน่งปัจจุบัน"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          locale="th"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editpersonnel_temporary.date_app_positonnow"
                        no-title
                        scrollable
                        locale="th"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu6 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu6.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <small
                  >* *ไม่สามาถแก้ไขเลขบัตรประจำประชาชนได้
                  หากตรวจสอบแล้วพบข้อผิดพลาดในรหัสบัตรประชาชน ให้ติดต่อ
                  Admin</small
                >
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="editpersonnel_temporarydialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="editpersonnel_temporarySubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model govem_contractdialog -->
      <v-dialog v-model="govem_contractdialog" max-width="80%">
        <v-card class="" elevation="2">
          <embed
            :src="
              'https://hrvec.ovec.go.th/HRemployee_contract/' +
                govem_contract_pdf
            "
            width="100%"
            height="700px"
          />
        </v-card>
      </v-dialog>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        top
        elevation="2"
      >
        <div class="d-flex align-center">
          <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
          <span>{{ snackbar.text }}</span>
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            ปิด
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import personnel_bar from "../../components/admin/personnel_bar.vue";

export default {
  components: { personnel_bar },

  data() {
    return {
      loading: false,
      radiosTpyeOganize: "college",
      ApiKey: "HRvec2021",

      // Dialog states
      addpersonnel_temporarydialog: false,
      editpersonnel_temporarydialog: false,
      deletepersonnel_temporarydialog: false,
      csvpersonnel_temporarydialog: false,
      csvpersonnel_temporaryAssTeachdialog: false,
      csvpersonnel_temporaryOutofdialog: false,
      govem_contractdialog: false,

      // Menu states
      menu5: false,
      menu6: false,
      menu8: false,

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // Data arrays
      personnel_temporarys: [],
      personnel_sCounts: [],
      personnel_temporary_idpositions: [],
      users: [],
      userstatus: [],
      man_powers: [],
      prefixs: [],
      veivocals: [],

      // Data objects
      addpersonnel_temporary: {},
      editpersonnel_temporary: {},
      del_personnel_temporary_del: {},
      updateJ18s: {},
      delmanage_assistant_teacher: {},
      data_syslog: {},
      user: {},

      // Search fields
      search: "",
      search_postion: "",
      college_search: {},
      position_search: {},
      rangname_search: {},
      user_status_search: "",

      // File uploads
      file2: null,
      file3: null,
      govem_contract_pdf: "",

      // Date
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      validateInputcheck: [],

      // Headers
      personnel_sHeaders: [
        { text: "ประเภท", align: "center", value: "position_name" },
        { text: "จำนวน", align: "center", value: "count_grouptype" }
      ],

      headers: [
        { text: "Login", align: "center", value: "Login" },
        { text: "แก้ไข", align: "center", value: "actions" },
        { text: "ลบ", align: "center", value: "dels" },
        { text: "ดูประวัติ", align: "left", value: "viewId" },
        { text: "สัญญาจ้าง", align: "center", value: "govem_contract" },
        { text: "สังกัด", align: "left", value: "agencys" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "id_card" },
        { text: "คำนำ", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "สกุล", align: "center", value: "last_name" },
        { text: "ตำแหน่ง", align: "center", value: "position_name" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "id_position" },
        { text: "วิทยฐานะ", align: "center", value: "rang_name" },
        { text: "ระดับ", align: "center", value: "rang_level" },
        { text: "วันเดือนปีเกิด", align: "center", value: "brith_day" },
        { text: "วันเดือนปีบรรจุ", align: "center", value: "appoin_day" },
        { text: "คำสั่งที่", align: "center", value: "order_app_now" },
        {
          text: "วันที่ปฏิบัติหน้าที่ ณ สถานศึกษาปัจจุบัน",
          align: "center",
          value: "date_app_now"
        },
        {
          text: "วันที่ดำรงตำแหน่งปัจจุบัน",
          align: "center",
          value: "date_app_positonnow"
        },
        { text: "เกษียณ", align: "center", value: "retrire_year" }
      ],

      // Static data
      delPersonneltype: [
        { text: "ลาออก", value: "resign" },
        { text: "ให้ออก", value: "discard" },
        { text: "ไล่ออก", value: "dismiss" },
        { text: "โอนย้าย", value: "transfer" },
        { text: "เกษียณ", value: "retire" },
        { text: "เสียชีวิต", value: "died" },
        { text: "สละสิทธิ์ไม่รายงานตัว", value: "disclaim" }
      ],

      position_select: [
        { text: "ผู้อำนวยการสถาบัน", value: "ผู้อำนวยการสถาบัน" },
        { text: "ผู้อำนวยการวิทยาลัย", value: "ผู้อำนวยการวิทยาลัย" },
        { text: "รองผู้อำนวยการวิทยาลัย", value: "รองผู้อำนวยการวิทยาลัย" },
        { text: "อาจารย์", value: "อาจารย์" },
        { text: "ผู้ช่วยศาสตราจารย์", value: "ผู้ช่วยศาสตราจารย์" },
        { text: "รองศาสตราจารย์", value: "รองศาสตราจารย์" },
        { text: "ศาสตราจารย์", value: "ศาสตราจารย์" },
        { text: "ครู", value: "ครู" },
        { text: "ครูผู้ช่วย", value: "ครูผู้ช่วย" },
        { text: "ศึกษานิเทศก์", value: "ศึกษานิเทศก์" },
        { text: "เจ้าพนักงานธุรการ", value: "เจ้าพนักงานธุรการ" },
        {
          text: "เจ้าพนักงานการเงินและบัญชี",
          value: "เจ้าพนักงานการเงินและบัญชี"
        },
        { text: "นักวิเคราะห์นโยบายและแผน", value: "นักวิเคราะห์นโยบายและแผน" },
        { text: "นักวิชาการเงินและบัญชี", value: "นักวิชาการเงินและบัญชี" },
        { text: "เจ้าพนักงานพัสดุ", value: "เจ้าพนักงานพัสดุ" }
      ],

      type_personnelApp: [
        { text: "ครูพัฒนาท้องถิ่น", value: "local_dev" },
        { text: "ครูโอนย้าย", value: "transfer_position" },
        { text: "คัดเลือก(ภายใน)", value: "select" },
        { text: "แข่งขัน(ภายนอก)", value: "recruit" }
      ],

      rang_names: [
        { text: "ต้น", value: "ต้น" },
        { text: "ปฏิบัติงาน", value: "ปฏิบัติงาน" },
        { text: "ปฏิบัติการ", value: "ปฏิบัติการ" },
        { text: "ครูผู้ช่วย", value: "ครูผู้ช่วย" },
        { text: "ครู", value: "ครู" },
        { text: "ชำนาญงาน", value: "ชำนาญงาน" },
        { text: "ชำนาญการ", value: "ชำนาญการ" },
        { text: "ชำนาญการพิเศษ", value: "ชำนาญการพิเศษ" },
        { text: "เชี่ยวชาญ", value: "เชี่ยวชาญ" },
        { text: "เชี่ยวชาญพิเศษ", value: "เชี่ยวชาญพิเศษ" }
      ],

      rang_levels: [
        { text: "ครูผู้ช่วย", value: "ครูผู้ช่วย" },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" }
      ],

      days: Array.from({ length: 31 }, (_, i) => ({
        text: String(i + 1),
        value: String(i + 1)
      })),

      mounts: Array.from({ length: 12 }, (_, i) => ({
        text: String(i + 1),
        value: String(i + 1)
      })),

      years: Array.from({ length: 71 }, (_, i) => {
        const year = 2500 + i;
        return { text: String(year), value: String(year) };
      })
    };
  },

  async mounted() {
    await this.initializeData();
  },

  computed: {
    filteredHeaders() {
      return this.user.userauthority_govem === "1"
        ? this.headers.filter(h => h.value !== "ac")
        : this.headers;
    },

    time_stamp() {
      return new Date().getTime();
    },

    retrire_year() {
      const mm = this.brith_month;
      const yy_retire = this.brith_year;
      return mm > 9 ? yy_retire + 61 : yy_retire + 60;
    },

    date_today_log() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  },

  methods: {
    // Initialize
    async initializeData() {
      try {
        await this.userQueryAll();
        await this.sweetAlertLoading();

        await Promise.all([
          this.loadUsers(),
          this.loadUserStatus(),
          this.loadPrefixes(),
          this.loadVeivocals(),
          this.personnel_temporaryCount()
        ]);

        Swal.close();
      } catch (error) {
        console.error("Error initializing data:", error);
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      }
    },

    async loadUsers() {
      const result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        admin: "Ok"
      });
      this.users = result.data;
    },

    async loadUserStatus() {
      const result = await this.$http.post("user_status.php", {
        ApiKey: this.ApiKey
      });
      this.userstatus = result.data;
    },

    async loadPrefixes() {
      const result = await this.$http.post("prefix.php", {
        ApiKey: this.ApiKey
      });
      this.prefixs = result.data;
    },

    async loadVeivocals() {
      const result = await this.$http.post("veivocal.php", {
        ApiKey: this.ApiKey
      });
      this.veivocals = result.data;
    },

    // User
    async userQueryAll() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      const result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = result.data;
    },

    async userLogin(id_card, p_word) {
      const result = await this.$http.post("login.php?crud=userByAdmin", {
        id_card,
        p_word
      });

      if (result.data.user_status) {
        const user = { ...result.data, system_lock: false };
        sessionStorage.setItem("user", JSON.stringify(user));

        const validStatuses = [
          "teacher",
          "se_director",
          "director",
          "S",
          "C",
          "38",
          "3801",
          "3802",
          "3803",
          "gov_em"
        ];

        if (validStatuses.includes(user.user_status)) {
          this.$router.push("/user");
        } else {
          sessionStorage.clear();
          this.showError("ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง");
        }
      }
    },

    // Search methods
    async searchPersonnel(params) {
      await this.sweetAlertLoading();
      this.loading = true;

      try {
        const result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          ...params
        });
        this.personnel_temporarys = result.data;
      } finally {
        this.loading = false;
        Swal.close();
      }
    },

    async search_name() {
      await this.searchPersonnel({ frist_name: this.search });
    },

    async search_lastname() {
      await this.searchPersonnel({ last_name: this.search });
    },

    async search_idcard() {
      await this.searchPersonnel({ id_cards: this.search });
    },

    async search_idposition() {
      await this.searchPersonnel({ id_position: this.search });
    },

    async search_idpositionClick(id_position) {
      await this.searchPersonnel({ id_position });
    },

    async search_college() {
      await this.searchPersonnel({ college_code: this.college_search });
    },

    async search_position() {
      await this.searchPersonnel({ position_name: this.position_search });
    },

    async search_rang() {
      await this.searchPersonnel({ rang_name: this.rangname_search });
    },

    async search_yearretire() {
      await this.searchPersonnel({ retrire_year: this.search });
    },

    async search_user_status() {
      await this.searchPersonnel({ user_status: this.user_status_search });
    },

    async clearSearch() {
      this.college_search = "";
      this.position_search = "";
      this.rangname_search = "";
      this.user_status_search = "";
    },

    // Personnel operations
    async personnel_temporaryCount() {
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        countTypePerson: "Ok"
      });
      this.personnel_sCounts = result.data;
    },

    async personnel_temporaryQueryAll() {
      await this.searchPersonnel({});
    },

    personnel_temporaryAdd() {
      this.addpersonnel_temporary = {};
      this.addpersonnel_temporarydialog = true;
    },

    personnel_temporaryCSV() {
      this.csvpersonnel_temporarydialog = true;
    },

    personnel_temporaryAssTeachCSV() {
      this.csvpersonnel_temporaryAssTeachdialog = true;
    },

    personnel_temporaryOutofCSV() {
      this.csvpersonnel_temporaryOutofdialog = true;
    },

    async personnel_temporaryEdit(id_card) {
      await this.sweetAlertLoading();

      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card
      });

      this.editpersonnel_temporary = result.data;
      this.editpersonnel_temporary.p_word = "";

      if (this.editpersonnel_temporary.college_code) {
        await this.man_powerQuery();
      }

      this.validateInput();
      this.editpersonnel_temporarydialog = true;
      Swal.close();
    },

    async personnel_temporaryDelete(id_card) {
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card
      });
      this.editpersonnel_temporary = result.data;
      this.deletepersonnel_temporarydialog = true;
    },

    // Submit methods
    async addpersonnel_temporarySubmit() {
      if (!this.$refs.addpersonnel_temporaryform.validate()) return;

      this.addpersonnel_temporary.ApiKey = this.ApiKey;
      this.addpersonnel_temporary.p_word = `${this.addpersonnel_temporary.brith_day}/${this.addpersonnel_temporary.brith_month}/${this.addpersonnel_temporary.brith_year}`;

      const result = await this.$http.post(
        "personnel_temporary.insert.php",
        this.addpersonnel_temporary
      );

      if (result.data.status) {
        this.showSuccess("ดำเนินการบันทึกข้อมูลเรียบร้อย");
        await this.logAction("insert", result.data.id_card);
      } else {
        this.showError("บันทึกข้อมูลผิดพลาด");
      }

      this.addpersonnel_temporarydialog = false;
    },

    async editpersonnel_temporarySubmit() {
      if (!this.$refs.editpersonnel_temporaryform.validate()) return;

      this.editpersonnel_temporary.ApiKey = this.ApiKey;

      if (!this.editpersonnel_temporary.p_word) {
        delete this.editpersonnel_temporary.p_word;
      }

      if (!this.editpersonnel_temporary.rang_condition) {
        this.editpersonnel_temporary.rang_condition = "0";
      }

      const result = await this.$http.post(
        "personnel_temporary.update.admin.php",
        this.editpersonnel_temporary
      );

      if (result.data.status) {
        this.showSuccess("ดำเนินการแก้ไขข้อมูลเรียบร้อย");
        await this.UpdateJ18();
        await this.logAction("update", result.data.id_card);
      } else {
        this.showError("ดำเนินการผิดพลาด");
      }

      this.editpersonnel_temporarydialog = false;
    },

    async deletepersonnel_temporarySubmit() {
      if (!this.$refs.deletepersonnel_temporaryform.validate()) return;

      await this.prepareDeleteData();

      const [
        resultIns,
        resultDel,
        resultJ18,
        resultDelMan
      ] = await Promise.all([
        this.$http.post(
          "personnel_temporary_del.insert.php",
          this.del_personnel_temporary_del
        ),
        this.$http.post(
          "personnel_temporary.delete.php",
          this.editpersonnel_temporary
        ),
        this.$http.post("jor18.updateIdPosition.php", this.updateJ18s),
        this.$http.post(
          "manage_assistant_teacher.deleteidcardandidpos.php",
          this.delmanage_assistant_teacher
        )
      ]);

      if (resultDel.data.status && resultJ18.data.status) {
        this.showSuccess("ดำเนินการลบข้อมูลเรียบร้อย");
        await this.UpdateJ18();
        await this.logAction("delete", resultDel.data.id_card);
        this.clearSearch();
      } else {
        this.showError("ดำเนินการลบผิดพลาด");
      }

      this.deletepersonnel_temporarydialog = false;
    },

    async prepareDeleteData() {
      this.editpersonnel_temporary.ApiKey = this.ApiKey;

      Object.assign(this.del_personnel_temporary_del, {
        ApiKey: this.ApiKey,
        ptdel_college_code: this.editpersonnel_temporary.college_code,
        ptdel_id_card: this.editpersonnel_temporary.id_card,
        ptdel_title_s: this.editpersonnel_temporary.title_s,
        ptdel_frist_name: this.editpersonnel_temporary.frist_name,
        ptdel_last_name: this.editpersonnel_temporary.last_name,
        ptdel_position_name: this.editpersonnel_temporary.position_name,
        ptdel_id_position: this.editpersonnel_temporary.id_position,
        ptdel_salary_s: this.editpersonnel_temporary.salary_s,
        ptdel_rang_name: this.editpersonnel_temporary.rang_name,
        ptdel_rang_level: this.editpersonnel_temporary.rang_level,
        ptdel_ed_abb: this.editpersonnel_temporary.ed_abb,
        ptdel_ed_name: this.editpersonnel_temporary.ed_name,
        ptdel_brith_day: this.editpersonnel_temporary.brith_day,
        ptdel_brith_month: this.editpersonnel_temporary.brith_month,
        ptdel_brith_year: this.editpersonnel_temporary.brith_year,
        ptdel_appoin_day: this.editpersonnel_temporary.appoin_day,
        ptdel_appoin_month: this.editpersonnel_temporary.appoin_month,
        ptdel_appoin_year: this.editpersonnel_temporary.appoin_year,
        ptdel_retire_year: this.editpersonnel_temporary.retrire_year,
        ptdel_datetime: this.date_today_log
      });

      const delTypeMap = {
        resign: "ลาออก",
        discard: "ให้ออก",
        dismiss: "ไล่ออก",
        transfer: "โอนย้าย",
        retire: "เกษียณ",
        died: "เสียชีวิต",
        disclaim: "สละสิทธิ์ไม่รายงานตัว"
      };

      const j18_background =
        delTypeMap[this.del_personnel_temporary_del.ptdel_status_del];

      Object.assign(this.updateJ18s, {
        ApiKey: this.ApiKey,
        id_position: this.editpersonnel_temporary.id_position,
        positions: this.editpersonnel_temporary.position_name,
        j18_background: `${j18_background}:${this.del_personnel_temporary_del.ptdel_datetime_outof}`
      });

      Object.assign(this.delmanage_assistant_teacher, {
        ApiKey: this.ApiKey,
        mt_id_card: this.editpersonnel_temporary.id_card,
        mt_id_position: this.editpersonnel_temporary.id_position
      });
    },

    // CSV Import methods
    async csvpersonnel_temporarySubmit() {
      await this.uploadCSV(
        this.file2,
        "personnel.csv",
        "personnel_importcsv.php"
      );
      this.csvpersonnel_temporarydialog = false;
    },

    async csvpersonnel_temporaryTeachAssSubmit() {
      await this.uploadCSV(
        this.file3,
        "personnel.csv",
        "personnel_importTeachAsscsv.php"
      );
      this.csvpersonnel_temporaryAssTeachdialog = false;
    },

    async csvpersonnel_temporaryOutofSubmit() {
      await this.uploadCSV(
        this.file2,
        "personnelretried.csv",
        "personnel_importretriedcsv.php"
      );
      this.csvpersonnel_temporaryOutofdialog = false;
    },

    async uploadCSV(file, filenamePrefix, endpoint) {
      if (!file) return;

      await this.sweetAlertLoading();

      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "filename",
        `../HRvecfiles/${this.time_stamp}.${filenamePrefix}`
      );
      formData.append("ApiKey", this.ApiKey);

      try {
        const result = await this.$http.post(endpoint, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        if (result.data.status) {
          this.showSuccess("ดำเนินการบันทึกข้อมูลเรียบร้อย");
          await this.UpdateJ18();
        } else {
          this.showError("ดำเนินการผิดพลาด");
        }
      } finally {
        Swal.close();
      }
    },

    // Utility methods
    async UpdateJ18() {
      await this.sweetAlertLoading();

      const data = { ApiKey: this.ApiKey };
      const [resulta, resultb] = await Promise.all([
        this.$http.post("jor18.update.php", data),
        this.$http.post("jor18.update.admin.php", data)
      ]);

      if (resulta.data.status && resultb.data.status) {
        this.showSuccess("ดำเนินการบันทึกข้อมูลเรียบร้อย");
      } else {
        this.showError("ดำเนินการผิดพลาด");
      }

      Swal.close();
    },

    async man_powerQuery() {
      const datasearch =
        this.editpersonnel_temporary.college_code ||
        this.addpersonnel_temporary.college_code;

      if (datasearch) {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          j18college_code: datasearch
        });
        this.man_powers = result.data;
      }
    },

    async clearRetireSearch() {
      const result = await Swal.fire({
        title: "ต้องการลบผู้เกษียณอายุราชการปี",
        text: this.search,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });

      if (!result.isConfirmed) return;

      const data = {
        ApiKey: this.ApiKey,
        retrire_year: this.search
      };

      try {
        const resultIns = await this.$http.post(
          "personnel_temporary.retire.update.php",
          data
        );

        if (resultIns.data.status) {
          const resultDel = await this.$http.post(
            "personnel_temporary.retire.delete.php",
            data
          );

          if (resultDel.data.status) {
            this.showSuccess("ดำเนินการข้อมูลเรียบร้อย");
          } else {
            this.showError("ผิดพลาด");
          }
        } else {
          this.showError("ผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
      }
    },

    async repleteSearch() {
      await this.sweetAlertLoading();
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        repetitive: "ok"
      });
      this.personnel_temporary_idpositions = result.data;
      Swal.close();
    },

    govem_contract_showDialog(govem_contract) {
      this.govem_contract_pdf = govem_contract;
      this.govem_contractdialog = true;
    },

    // Validation
    validateInputAdd() {
      this.validateInputcheck = this.validateIdCard(
        this.addpersonnel_temporary.id_card
      );
    },

    validateInput() {
      this.validateInputcheck = this.validateIdCard(
        this.editpersonnel_temporary.id_card
      );
    },

    validateIdCard(value) {
      if (!value || value.length !== 13 || !/^\d+$/.test(value)) {
        return "false";
      }

      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(value.charAt(i)) * (13 - i);
      }

      const check = (11 - (sum % 11)) % 10;
      return check === parseInt(value.charAt(12)) ? "true" : "false";
    },

    // Alert helpers
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showError(message) {
      Swal.fire({
        icon: "warning",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showSnackbar(text, color = "success", icon = "mdi-check") {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 5000
      };
    },

    // Logging
    async logAction(eventType, id_card) {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};

      const logData = {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name,
        event_log: eventType,
        page_log: "personnel_temporary",
        table_log: "personnel_temporary",
        detail_log: id_card,
        date_times: this.date_today_log
      };

      await this.$http.post("data_syslog.insert.php", logData);
    },

    // Date calculations
    calculateBirthDate(dateString) {
      if (!dateString) return { day: "", month: "", year: "" };

      const date = new Date(dateString);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear() + 543
      };
    },

    calculateAge(birthDate) {
      if (!birthDate) return "";

      const today = new Date();
      const dob = new Date(birthDate);

      let years = today.getFullYear() - dob.getFullYear();
      let months = today.getMonth() - dob.getMonth();
      let days = today.getDate() - dob.getDate();

      if (days < 0) {
        months--;
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        days += lastMonth.getDate();
      }

      if (months < 0) {
        years--;
        months += 12;
      }

      return `${years} ปี ${months} เดือน ${days} วัน`;
    },

    formatDate(date, addYears = 543) {
      if (!date) return "";

      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear() + addYears;

      return `${day}/${month}/${year}`;
    },

    formatDateTime(date) {
      if (!date) return "";

      const d = new Date(date);
      const dateStr = this.formatDate(date);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      return `${dateStr} ${hours}:${minutes}:${seconds}`;
    },

    // Helper methods
    async OnEnter() {
      await this.search_name();
    },

    resetDialogs() {
      this.addpersonnel_temporarydialog = false;
      this.editpersonnel_temporarydialog = false;
      this.deletepersonnel_temporarydialog = false;
      this.csvpersonnel_temporarydialog = false;
      this.csvpersonnel_temporaryAssTeachdialog = false;
      this.csvpersonnel_temporaryOutofdialog = false;
    },

    resetForm(formRef) {
      if (this.$refs[formRef]) {
        this.$refs[formRef].reset();
        this.$refs[formRef].resetValidation();
      }
    }
  }
};
</script>
<style scoped>
/* Modern Layout */
.personnel-management {
  background: #f5f7fa;
  min-height: 100vh;
}

.nav-wrapper {
  background: white;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 24px;
}

/* Header Card */
.header-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e0e0e0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  background: #f0f4ff;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.3;
}

.header-subtitle {
  font-size: 14px;
  color: #666;
  margin: 4px 0 0 0;
}

/* Card Styles */
.card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  margin-bottom: 16px;
}

.card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

/* Stats Card */
.stats-card {
  height: 100%;
}

.count-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

/* Info Card */
.info-card {
  text-align: center;
  padding: 40px 24px;
}

.info-icon-wrapper {
  background: #f0f4ff;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.info-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* Action Panel */
.action-panel {
  padding: 16px;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
  border-radius: 8px;
}

.action-btn .v-icon {
  font-size: 20px;
}

/* Search Card */
.search-card {
  padding: 24px;
}

.search-header {
  margin-bottom: 20px;
}

.search-field {
  font-size: 14px;
}

.search-field-compact {
  max-width: 250px;
}

.search-radio {
  margin-top: 0 !important;
}

.search-radio .v-radio {
  margin-right: 16px;
}

.search-radio .v-label {
  font-size: 14px;
  color: #666;
}

.filter-select .v-input__control {
  min-height: 40px !important;
}

/* Duplicate Card */
.duplicate-card {
  height: 100%;
}

/* Data Table Card */
.data-table-card {
  margin-bottom: 24px;
}

/* Clean Table */
.clean-table {
  font-size: 14px;
}

.clean-table thead {
  background: #fafafa;
}

.clean-table thead th {
  color: #666 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e0e0e0 !important;
}

.clean-table tbody tr {
  transition: background-color 0.2s;
}

.clean-table tbody tr:hover {
  background-color: #f8f9fa !important;
}

.clean-table tbody td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 48px 24px;
  color: #999;
}

/* Responsive */
@media (max-width: 960px) {
  .main-container {
    padding: 16px;
  }

  .header-card {
    padding: 16px;
  }

  .header-title {
    font-size: 20px;
  }

  .card-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .search-field-compact {
    max-width: 100%;
  }

  .action-panel {
    padding: 12px;
  }

  .search-card {
    padding: 16px;
  }
}

/* Form Styles */
.v-text-field--outlined fieldset {
  border-color: #e0e0e0;
}

.v-text-field--outlined:not(.v-input--is-focused):not(.error--text) fieldset {
  border-color: #e0e0e0;
}

.v-text-field--outlined.v-input--is-focused fieldset {
  border-width: 1px;
}

/* Button Overrides */
.v-btn:not(.v-btn--text):not(.v-btn--outlined) {
  box-shadow: none !important;
}

.v-btn--outlined {
  border-width: 1px;
}

/* Chip Styles */
.v-chip {
  font-weight: 500;
  font-size: 13px;
}

/* Dialog Overrides */
.v-dialog > .v-card {
  border-radius: 12px;
}

.v-dialog .v-card__title {
  font-weight: 600;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

/* Divider */
.v-divider {
  border-color: #e0e0e0;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f7fa;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
</style>
